let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}

;(() => {
  if (window.__yesArtYesFunnelFixes) return;
  window.__yesArtYesFunnelFixes = true;

  const productFormSelector = 'form[action*="/cart/add"]';
  const preferredSquareSizes = ['20x20', '24x24', '30x30', '32x32', '36x36', '16x16', '14x14', '12x12', '10x10'];
  let defaultSizeLocked = false;
  let stickyUpdateFrame = null;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cleanText(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isProductPage() {
    return location.pathname.indexOf('/products/') !== -1 && document.querySelector(productFormSelector);
  }

  function injectStyles() {
    if (document.getElementById('yay-funnel-fixes-style')) return;

    const style = document.createElement('style');
    style.id = 'yay-funnel-fixes-style';
    style.textContent = `
      .product__info-container .product-form__quantity {
        display: none !important;
      }

      .yay-most-popular-badge {
        display: inline-block;
        margin-left: 0.6rem;
        padding: 0.25rem 0.7rem;
        border-radius: 999px;
        background: #111111;
        color: #ffffff;
        font-size: 1.1rem;
        line-height: 1;
        font-weight: 700;
        white-space: nowrap;
        vertical-align: middle;
      }

      .yay-mobile-atc {
        display: none;
      }

      @media screen and (max-width: 749px) {
        body.yay-product-page {
          padding-bottom: 9rem;
        }

        .yay-mobile-atc {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2147483000;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1.2rem;
          padding: 1rem 1.4rem calc(1rem + env(safe-area-inset-bottom));
          background: #ffffff;
          border-top: 1px solid rgba(18, 18, 18, 0.14);
          box-shadow: 0 -0.8rem 2.4rem rgba(18, 18, 18, 0.12);
        }

        .yay-mobile-atc__text {
          min-width: 0;
          display: grid;
          gap: 0.2rem;
        }

        .yay-mobile-atc__title {
          max-width: 16rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 1.2rem;
          line-height: 1.2;
          color: #121212;
        }

        .yay-mobile-atc__price {
          font-size: 1.5rem;
          line-height: 1.2;
          font-weight: 700;
          color: #121212;
        }

        .yay-mobile-atc__button {
          min-width: 14rem;
          min-height: 4.6rem;
          border: 0;
          border-radius: 0.4rem;
          background: #121212;
          color: #ffffff;
          font-size: 1.5rem;
          font-weight: 700;
          cursor: pointer;
        }

        .yay-mobile-atc__button[disabled] {
          opacity: 0.55;
          cursor: not-allowed;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeSizeNumber(value) {
    return String(Number(value));
  }

  function squareSizeFromText(value) {
    const match = value.toLowerCase().match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*inch/);
    if (!match) return null;

    const width = Number(match[1]);
    const height = Number(match[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
    if (Math.abs(width - height) > 0.01) return null;

    return normalizeSizeNumber(match[1]) + 'x' + normalizeSizeNumber(match[2]);
  }

  function labelForInput(input, fieldset) {
    return Array.from(fieldset.querySelectorAll('label')).find((label) => label.htmlFor === input.id || label.contains(input));
  }

  function getSizeFieldset() {
    return Array.from(document.querySelectorAll('fieldset')).find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      return /size/i.test(cleanText(legend)) && fieldset.querySelector('input[type="radio"]');
    });
  }

  function addMostPopularBadge(label) {
    if (!label || label.querySelector('.yay-most-popular-badge')) return;

    const badge = document.createElement('span');
    badge.className = 'yay-most-popular-badge';
    badge.textContent = 'Most popular';
    label.appendChild(badge);
  }

  function selectPreferredSquareSize() {
    if (defaultSizeLocked) return;
    if (new URLSearchParams(location.search).has('variant')) return;

    const fieldset = getSizeFieldset();
    if (!fieldset) return;

    const options = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
      .map((input) => {
        const label = labelForInput(input, fieldset);
        return {
          input,
          label,
          size: squareSizeFromText(cleanText(label)),
        };
      })
      .filter((option) => option.label && option.size);

    if (options.length < 4) return;

    const target = preferredSquareSizes
      .map((size) => options.find((option) => option.size === size))
      .find(Boolean);

    if (!target) return;

    defaultSizeLocked = true;
    addMostPopularBadge(target.label);

    if (!target.input.checked) {
      target.label.click();
      target.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getMainAddButton() {
    const buttons = Array.from(document.querySelectorAll(`${productFormSelector} button[type="submit"], product-form button[type="submit"]`));
    return buttons.find((button) => !button.closest('.yay-mobile-atc')) || null;
  }

  function getCurrentPrice() {
    const container = document.querySelector('.product__info-container') || document;
    const candidates = Array.from(container.querySelectorAll('.price-item--sale, .price-item--regular, [role="status"], .price'));

    for (const element of candidates) {
      const matches = cleanText(element).match(/\$\s?\d[\d,.]*(?:\s?USD)?/g);
      if (matches && matches.length) {
        return matches[matches.length - 1].replace(/\s+/g, ' ');
      }
    }

    return '';
  }

  function forceQuantityOne() {
    document.querySelectorAll(`${productFormSelector} input[name="quantity"]`).forEach((input) => {
      input.value = '1';
    });
  }

  function updateStickyAtc() {
    const bar = document.querySelector('.yay-mobile-atc');
    if (!bar) return;

    const mainButton = getMainAddButton();
    const stickyButton = bar.querySelector('.yay-mobile-atc__button');
    const title = bar.querySelector('.yay-mobile-atc__title');
    const price = bar.querySelector('.yay-mobile-atc__price');

    title.textContent = cleanText(document.querySelector('h1')) || 'Canvas wall art';
    price.textContent = getCurrentPrice();

    const disabled = !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
    stickyButton.disabled = disabled;
    stickyButton.textContent = disabled ? cleanText(mainButton) || 'Unavailable' : 'Add to cart';
  }

  function scheduleStickyUpdate() {
    if (stickyUpdateFrame) cancelAnimationFrame(stickyUpdateFrame);
    stickyUpdateFrame = requestAnimationFrame(updateStickyAtc);
  }

  function createStickyAtc() {
    if (document.querySelector('.yay-mobile-atc')) return;
    if (!getMainAddButton()) return;

    const bar = document.createElement('div');
    bar.className = 'yay-mobile-atc';
    bar.innerHTML = '<div class="yay-mobile-atc__text"><span class="yay-mobile-atc__title"></span><span class="yay-mobile-atc__price"></span></div><button class="yay-mobile-atc__button" type="button">Add to cart</button>';

    bar.querySelector('.yay-mobile-atc__button').addEventListener('click', () => {
      forceQuantityOne();
      const mainButton = getMainAddButton();
      if (mainButton && !mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true') {
        mainButton.click();
      }
    });

    document.body.appendChild(bar);
    updateStickyAtc();

    document.addEventListener('change', () => {
      forceQuantityOne();
      window.setTimeout(scheduleStickyUpdate, 150);
    }, true);

    const observer = new MutationObserver(scheduleStickyUpdate);
    observer.observe(document.querySelector('.product__info-container') || document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  ready(() => {
    if (!isProductPage()) return;

    document.body.classList.add('yay-product-page');
    injectStyles();
    forceQuantityOne();
    createStickyAtc();
    window.setTimeout(selectPreferredSquareSize, 400);
    window.setTimeout(selectPreferredSquareSize, 1200);
  });
})();